import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { blogPosts, blogCategories } from '../data/blogPosts';

const Blog = () => {
  // Show first 6 on homepage
  const featured = blogPosts.slice(0, 6);

  return (
    <section className="bg-white py-16 sm:py-20" id="blog" data-testid="blog-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 sm:mb-12">
          <div>
            <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3">
              Free Market Education
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-3">
              Educational <span className="text-green-600">Blog & Research</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl">
              Practical stock market education by Deepak Singhai — for traders in Bhopal and across India.
            </p>
          </div>
          <Link
            to="/blog"
            className="inline-flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white font-bold px-5 py-2.5 rounded-lg transition-colors text-sm flex-shrink-0"
            data-testid="view-all-blogs-btn"
          >
            View All {blogPosts.length} Articles <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((post) => {
            const Icon = Icons[post.icon] || Icons.BookOpen;
            const cat = blogCategories[post.category];
            return (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group block bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-green-600 hover:-translate-y-1 transition-all duration-200"
                data-testid={`home-blog-card-${post.slug}`}
              >
                <div className="h-36 bg-green-100 flex items-center justify-center">
                  <Icon className="h-14 w-14 text-green-600" strokeWidth={1.5} />
                </div>
                <div className="p-6">
                  <span className={`inline-block ${cat.color} text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded mb-3`}>
                    {cat.label}
                  </span>
                  <h4 className="text-base font-bold text-gray-900 leading-snug mb-2 group-hover:text-green-700 transition-colors">
                    {post.title}
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-bold text-green-600 group-hover:gap-2 transition-all">
                    Read Article <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Blog;
